import React from 'react'

import { BaseBatchTransactions } from './BaseBatchTransactions'

interface Props {}

export function VoidTransactions (_props: Props) {
  return (
    <BaseBatchTransactions
      searchType='voidable'
      action='void'
      helpLink='https://paytrace.atlassian.net/wiki/spaces/HD/pages/2025783819/Void+Transactions'
      title='Void Transactions'
    />
  )
}

export default VoidTransactions
